export default {"src":"/_next/static/media/gbp.39c22939.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};